import {
  FormControlLabel as MuiFormControlLabel,
  Radio as MuiRadio,
} from "@mui/material";
import { type ChangeEvent, type ReactNode, type Ref } from "react";

export type RadioProps = {
  value?: string | number | boolean;
  disabled?: boolean;
  size?: "small" | "medium";
  onChange?: (event: ChangeEvent<HTMLInputElement>, checked: boolean) => void;
  checked?: boolean;
  id?: string;
  name?: string;
  ref?: Ref<HTMLButtonElement>;
  label?: ReactNode;
  labelPlacement?: "end" | "start" | "top" | "bottom";
  className?: string;
};

export function Radio({
  ref,
  label,
  labelPlacement,
  className,
  value,
  ...props
}: RadioProps) {
  const radioControl = <MuiRadio {...props} value={value} ref={ref} />;

  if (label === undefined) {
    return radioControl;
  }

  return (
    <MuiFormControlLabel
      value={value}
      label={label}
      control={radioControl}
      labelPlacement={labelPlacement}
      className={className}
      disableTypography
    />
  );
}
